import { render } from "./ProUni50.vue?vue&type=template&id=370d91fa"
import script from "./ProUni50.vue?vue&type=script&lang=js"
export * from "./ProUni50.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__